import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getMessages = async (questionId) => {
  return await request.get(
    `/Question/notes`,
    { questionId },
    'При загрузке сообщений произошла ошибка',
    []
  );
};

const useQuestionMessages = (questionId, options) =>
  useQuery(
    questionsQueryKeys.questionMessages(questionId),
    () => getMessages(questionId),
    options
  );

export default useQuestionMessages;
